<template>
    <div>
        <ts-loading-banner :loading="loading">
            <form class="form-horizontal">
                <div class="row form-group">
                    <label class="col-form-label col-md-2 required">{{
                        $t('studentGallery.eventDate')
                    }}</label>
                    <div class="col-md-10">
                        <ts-date-picker-input v-model="model.event_date">
                        </ts-date-picker-input>
                        <div class="invalid-feedback" v-if="errors.has('event_date')">
                            {{ errors.first('event_date') }}
                        </div>
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-form-label col-md-2 required">{{
                        $t('studentGallery.eventName')
                    }}</label>
                    <div class="col-md-10">
                        <input type="text" class="form-control" v-model="model.event_name"
                            :class="{ 'is-invalid': errors.has('event_name') }" />
                        <div class="invalid-feedback" v-if="errors.has('event_name')">
                            {{ errors.first('event_name') }}
                        </div>
                    </div>
                </div>
								<div class="row form-group ts--mt-3">
									<div class="col-md-11"></div>
									<div class="col-md-1">
										<ts-checkbox @change="selectAllClass" v-model="model.is_all">All</ts-checkbox>
									</div>
								</div>
                <div class="row form-group ts--mt-4">
                    <label class="col-form-label col-md-2 required">{{
                        $t('studentGallery.className')
                    }}</label>
                    <div class="col-md-10">											
                        <a-select v-model="model.class_id" mode="multiple" style="width: 100%" :options="class_list"
                            :show-search="true" option-filter-prop="children" allowClear :filter-option="(input, option) =>
                                option.componentOptions.children[0].text
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                " @change="onClassChange" :class="{ 'is-invalid': errors.has('class_id') }"></a-select>
                        <div class="validate" v-if="errors.has('class_id')">
                            {{ errors.first('class_id') }}
                        </div>
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-form-label col-md-2">{{
                        $t('studentGallery.studentName')
                    }}</label>
                    <div class="col-md-10">
                        <a-select v-model="model.student_id" mode="multiple" style="width: 100%" :options="student_list" placeholder="All"
                            :show-search="true" option-filter-prop="children" allowClear :filter-option="(input, option) =>
                                option.componentOptions.children[0].text
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                "></a-select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 text-right">
                        <ts-button class="mr-2" @click="clearInput">{{
                            $t('cancel')
                        }}</ts-button>
                        <ts-button color="primary" @click.prevent="onUpdate" :waiting="waiting">
                            {{ $t("update") }}</ts-button>
                    </div>
                </div>
            </form>
        </ts-loading-banner>
    </div>
</template>
  
<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { mapState } from 'vuex'
import { isEmpty } from "lodash";
export default {
    name: 'edit',
    data() {
        return {
            loading: false,
            waiting: false,
            errors: new Errors(),
            class_list: [],
            student_list: [],
            model: {
							  is_all: false,
                upload_id: 0,
                event_date: moment().format('DD-MM-YYYY'),
                class_id: [],
                student_id: undefined,
                event_name: null,
            }
        }
    },
    created() {
        this.onClassChange()
        this.setEditData()
        this.fetchClass()
    },
    computed: {
        ...mapState("staffStudentGallery", ["edit_data"]),
    },
    methods: {
        async fetchClass() {
            await this.$store
                .dispatch('staffStudentGallery/getClassOperation')
                .then(response => {
                    this.class_list = response.data.map(el => ({
                        value: el.class_id,
                        label: el.class_name
                    }))
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        onClassChange() {
            this.loading = true
            this.student_list = []
            this.model.student_id = undefined
            this.$store
                .dispatch(
                    'staffStudentGallery/getStudentEnrollmentByClass',
                    this.model.class_id
                )
                .then(response => {
                    this.student_list = response.data
                        .filter(e => e.student_profile != null)
                        .map(el => ({
                            value: el.student_profile.student_id,
                            label:
                                el.student_profile.card_number +
                                '|' +
                                el.student_profile.full_name_en
                        }))
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        onUpdate() {
            this.errors = new Errors()
            this.waiting = true
            this.$store
                .dispatch('staffStudentGallery/update', this.model)
                .then(response => {
                    this.$toasted.success(response.message)
                    this.clearInput()
                    this.$emit('fetchData')
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                    this.errors = new Errors(error.errors)
                })
                .finally(() => {
                    this.waiting = false
                })
        },
        setEditData() {
            if (!isEmpty(this.edit_data)) {
                this.model.upload_id = this.edit_data.upload_id
                this.model.event_name = this.edit_data.event_name
                this.model.student_id = this.edit_data.student_list.map(el => el.student_id)
                this.model.event_date = this.edit_data.event_date
                this.model.class_id = this.edit_data.gallery_class.map(el => el.class_id)
				this.model.is_all = this.class_list.length == this.edit_data.gallery_class.map(el => el.class_id).length ? true : false
            }
        },
        clearInput() {
            this.$emit('close')
            this.errors = new Errors()
            this.model.upload_id = 0
            this.model.event_name = null
            this.model.class_id = []
            this.model.student_id = undefined
						this.model.is_all = false
            this.model.event_date = moment().format('DD-MM-YYYY')
        },
				selectAllClass (value) {
            if (value == true) {
						this.model.class_id = []
						
						this.class_list.forEach(el => {
							this.model.class_id.push(el.value)
						})
					} else {
						this.model.class_id = []
					}
				}
    }
}
</script>
  